import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Multiselect } from "multiselect-react-dropdown";
import { newDevelopmentActions, newDevelopmentSelectors } from "state/newDevelopment";
import { TooltipType } from "../../../../../../sharedComponents/Tooltip/config";
import { subscriptionSelectors } from "../../../../../../../state/subscription";
import { Tier } from "../../../../../../../types/Tier";

const STYLE = {
  chips: {
    background: "#3A4276",
    borderRadius: "0",
    textTransform: "capitalize",
  },
  searchBox: {
    border: "none",
    overflowX: "scroll",
  },
  multiselectContainer: {
    color: "FFFFFF",
  },
  optionContainer: {
    background: "#3A4276",
    color: "FFFFFF",
  },
  option: {
    color: "white",
    font: "Bold",
    textTransform: "capitalize",
  },
};

const AllowedUsesFilters = () => {
  const dispatch = useDispatch()
  const enabledAllowedUsesFilters = useSelector(newDevelopmentSelectors.getEnabledAllowedUsesFilters);
  const allowedUsesIds = useSelector(newDevelopmentSelectors.getAllowedUsesIds);
  const tier = useSelector(subscriptionSelectors.getTier);
  const isDemoUser = tier === Tier.None;
  const dataTip = isDemoUser ? TooltipType.SmartSearch : null;

  return (
    <div className="component--allowed-uses-filters">
      <div className="count-wrapper section-divisor">
        <label>Uses Allowed</label>
      </div>

      <div className="allowed-uses-dropdown-box" data-for="click-right" data-tip={dataTip}>
        <Multiselect
          options={allowedUsesIds}
          selectedValues={enabledAllowedUsesFilters}
          onSelect={(selectedList, allowedUse) => dispatch(newDevelopmentActions.updateAllowedUsesFilterValues({ [allowedUse]: true }))}
          onRemove={(selectedList, allowedUse) => dispatch(newDevelopmentActions.updateAllowedUsesFilterValues({ [allowedUse]: false }))}
          isObject={false}
          placeholder="Click here to search for uses allowed."
          style={STYLE}
          avoidHighlightFirstOption={true}
          closeIcon="cancel"
          id="allowed uses search input"
          disable={isDemoUser}
        />
      </div>

    </div>
  );
}

export default AllowedUsesFilters;
